<template>
  <div>
    <div id="screen-initial">
      <z-loading :active="loading" :is-full-page="true" />
      <h1 id="msg" class="hidden">Loading...</h1>
      <progress
        id="load-progress"
        class="hidden"
        max="100"
        value="0"></progress>
    </div>

    <div  class="flex mb-3 text-sm">
      <div
        class="flex items-center border-b-2 border-gray-300"
        :class="{ 'border-primary': !this.files['front'],
         'w-1/2': this.docType === 'scan-id' ,
          'w-full': this.docType === 'scan-passport' }">
        <div
          class="bg-primary rounded-full w-6 h-6 text-white flex justify-center items-center font-bold">
          1
        </div>
        <div class="p-3" v-if="this.docType === 'scan-id'">{{ $t('FrontSide') }}</div>
        <div class="p-3" v-if="this.docType === 'scan-passport'">{{ $t('UploadPassportImage') }}</div>
      </div>

      <div v-if="shouldScanBackSide"
        class="flex items-center w-1/2 border-b-2 border-gray-300"
        :class="{ 'border-primary': !!this.files['front'] }">
        <div
          class="bg-primary rounded-full w-6 h-6 text-white flex justify-center items-center font-bold">
          2
        </div>
        <div class="p-3">{{ $t('BackSide') }}</div>
      </div>
    </div>

    <div v-if="!uploading" class="flex flex-col space-y-3">
      <upload-button
        ref="uploadBtnFront"
        key="1"
        id-tag="image-file"
        v-if="!this.files['front']"
        @onfile="(e) => onFile(e, 'front')">
        <p class="text-white">
          {{ $t('Upload') }}
        </p>
      </upload-button>
      <upload-button
        ref="uploadBtnBack"
        key="2"
        id-tag="image-file-back"
        v-else-if="shouldScanBackSide"
        @onfile="(e) => onFile(e, 'back')">
        <p class="text-white">
          {{ $t('Upload') }}
        </p>
      </upload-button>
    </div>

    <p class="text-danger mt-1">{{ error }}</p>

    <div id="screen-scanning-upload" class="hidden text-center">
      <h1>Processing...</h1>
      <img id="target-image" alt="preview" class="hidden" src="#" />
    </div>
  </div>
</template>

<script>
import * as BlinkIDSDK from '@microblink/blinkid-in-browser-sdk'
import ZLoading from '@/zain-component-library/src/lib-components/ZLoading'
import microBlinkMixin from '@/mixins/microBlinkMixin'

const UploadButton = {
  name: 'UploadButton',
  inheritAttrs: true,
  props: {
    idTag: String,
    onChange: {
      type: Function
    }
  },
  data() {
    return {
      hasValue: false
    }
  },
  methods: {
    onFile(event) {
      this.hasValue = true
      this.$emit('onfile', event)
    }
  },
  template: `
    <div class='flex justify-center items-center w-full'>

    <label
      class='flex flex-col justify-center items-center w-full rounded-lg cursor-pointer relative dashed'


      :for='idTag'>
            <span class='flex flex-col justify-center items-center p-4'>

              <svg class='my-6' width='52' height='46' viewBox='0 0 52 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M7.33333 9.66699H10C11.4145 9.66699 12.771 9.10509 13.7712 8.10489C14.7714 7.1047 15.3333 5.74815 15.3333 4.33366C15.3333 3.62641 15.6143 2.94814 16.1144 2.44804C16.6145 1.94794 17.2928 1.66699 18 1.66699H34C34.7072 1.66699 35.3855 1.94794 35.8856 2.44804C36.3857 2.94814 36.6667 3.62641 36.6667 4.33366C36.6667 5.74815 37.2286 7.1047 38.2288 8.10489C39.229 9.10509 40.5855 9.66699 42 9.66699H44.6667C46.0812 9.66699 47.4377 10.2289 48.4379 11.2291C49.4381 12.2293 50 13.5858 50 15.0003V39.0003C50 40.4148 49.4381 41.7714 48.4379 42.7716C47.4377 43.7718 46.0812 44.3337 44.6667 44.3337H7.33333C5.91885 44.3337 4.56229 43.7718 3.5621 42.7716C2.5619 41.7714 2 40.4148 2 39.0003V15.0003C2 13.5858 2.5619 12.2293 3.5621 11.2291C4.56229 10.2289 5.91885 9.66699 7.33333 9.66699Z'
                  stroke='#E5E5E5' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' />
                <path
                  d='M26 33.667C30.4183 33.667 34 30.0853 34 25.667C34 21.2487 30.4183 17.667 26 17.667C21.5817 17.667 18 21.2487 18 25.667C18 30.0853 21.5817 33.667 26 33.667Z'
                  stroke='#E5E5E5' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' />
              </svg>

              <p class='text-sm text-gray-400 text-center'>{{ $t('UploadValidId') }}</p>

              <span :class="{'text-gray-400': hasValue, 'text-gray-500': !hasValue}"
                    class='text-sm font-semibold mt-6 mb-6 text-white bg-primary p-3 rounded'>
                <slot />
              </span>

            </span>

      <input :disabled='hasValue'
             :id='idTag'
             v-bind='$attrs'
             @change='onFile'
             accept='image/*'
             class='hidden'
             type='file' />
    </label>
    </div>
  `
}

export default {
  name: 'MBUpload',
  components: { ZLoading, UploadButton },
  mixins: [microBlinkMixin],
  props: {
    docType: {
      type: String,
      default: 'scan-id'
    }
  },
  computed: {
    shouldScanBackSide() {
      return this.docType === 'scan-id'
    }
  },
  data() {
    return {
      uploading: false,
      sdk: null,
      loading: true,
      frontSideDone: false,
      backSideDone: false,
      frontSideResults: null,
      backSideResults: null,
      error: null,
      files: {
        front: null,
        back: null
      }
    }
  },
  methods: {
    initMicroBlink() {
      this.loading = true
      if (BlinkIDSDK.isBrowserSupported()) {
        const initialMessageEl = document.getElementById('msg')
        const progressEl = document.getElementById('load-progress')

        const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(
          process.env.VUE_APP_MB_LIC
        )
        loadSettings.loadProgressCallback = (progress) =>
          (progressEl.value = progress)
        loadSettings.allowHelloMessage = true

        let vm = this
        BlinkIDSDK.loadWasmModule(loadSettings).then(
          (sdk) => {
            this.loading = false
            vm.sdk = sdk
          },
          (error) => {
            this.isLoading = false
            console.error('Failed to load SDK!', error)
            initialMessageEl.innerText = 'Failed to load SDK!'
            this.$emit('close', 'Error, please try again later')
          }
        )
      } else {
        this.isLoading = false
        console.log('This browser is not supported by the SDK!')
        this.$emit('close', 'Error, This browser is not supported')
      }
    },
    async onFile(event, side = 'front') {

      this.error = null

      if (!event.target?.files?.[0]?.size) {
        console.log('cant get size')
        return
      }

      const sizeInMb = event.target.files[0].size / 1024 / 1024

      if (sizeInMb > 8) {
        // this.$emit('close', 'File too big')
        this.error = 'File size too large, Maximum is 8 MB'
        this.resetButtons()
        return
      }

      if (event.target.files) {
        this.files[side] = event.target.files
      }

      if (
        !this.shouldScanBackSide ||
        (this.files['front'] && this.files['back'])
      )
        await this.startScan()
    },
    async startScan() {
      this.error = null
      this.loading = true

      const recognizer = await BlinkIDSDK.createBlinkIdCombinedRecognizer(
        this.sdk
      )

      const settings = await recognizer.currentSettings()
      settings.returnEncodedFullDocumentImage = true
      await recognizer.updateSettings(settings)

      const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
        this.sdk,
        [recognizer],
        false
      )
      const fileFrontSide = this.getImageFromInput(this.files.front)
      const imageFrame = await this.getImageFrame(fileFrontSide)
      const processResultFrontSide = await recognizerRunner.processImage(
        imageFrame
      )

      let results = null

      if (processResultFrontSide === BlinkIDSDK.RecognizerResultState.Empty) {
        this.error = 'Could not extract information'
        this.resetButtons()
        this.$emit('close', this.error)
        return
      }

      if (this.files.back) {
        const fileBackSide = this.getImageFromInput(this.files.back)
        const imageFrameBack = await this.getImageFrame(fileBackSide)
        const processResultBackSide = await recognizerRunner.processImage(
          imageFrameBack
        )

        if (processResultBackSide !== BlinkIDSDK.RecognizerResultState.Empty) {
          results = await recognizer.getResult()
        }
      } else {
        results = await recognizer.getResult()
      }

      await recognizerRunner?.delete()
      await recognizer?.delete()

      this.loading = false

      if (
        this.docType === 'scan-passport' &&
        (!results?.mrz.parsed || results?.mrz?.sanitizedDocumentCode !== 'P')
      ) {
        this.error =
          'Could not extract information, please make sure to upload a valid Passport page and try again'
        this.resetButtons()
        this.$emit('close', this.error)

        return
      }

      this.$emit('results', this.convertAllImagesToBase64(results))
    },

    getImageFromInput(fileList) {
      let image = null
      const imageRegex = RegExp(/^image\//)
      for (const element of fileList) {
        if (imageRegex.exec(element.type)) {
          image = element
        }
      }
      return image
    },
    async getImageFrame(file) {
      const scanImageElement = document.getElementById('target-image')
      scanImageElement.src = URL.createObjectURL(file)
      await scanImageElement.decode()
      return BlinkIDSDK.captureFrame(scanImageElement)
    },
    resetButtons() {
      if (this.$refs.uploadBtnFront) this.$refs.uploadBtnFront.hasValue = false
      if (this.$refs.uploadBtnBack) this.$refs.uploadBtnBack.hasValue = false
    }
  },
  mounted() {
    this.initMicroBlink()
  }
}
</script>

<style>
html {
  overflow: hidden !important;
}

.dashed {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23E1E1E1FF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>
